
import axios from 'axios';
import authHeader from './auth-header'; // Asegúrate de que esto esté configurado

const API_URL = process.env.VUE_APP_API_BASE_URL;

export default {
    getAll(data=null) {
        const queryString = new URLSearchParams(data).toString();
        const url = `${API_URL}/remissions?${queryString}`; 

        return axios.get(url, { headers: authHeader() });
    },
    getData(id) {
        return axios.get(`${API_URL}/remissions/${id}`, { headers: authHeader() });
    },
    createData(data) {
        const loggedUser = JSON.parse(localStorage.getItem('user'));
        if (!loggedUser || !loggedUser.id) {
            throw new Error('User ID no válido. Asegúrate de haber iniciado sesión.');
        }

        const clientId = Number(data.client_id ?? data.user_id ?? 0);
        if (!clientId) {
            throw new Error('Debe seleccionar un cliente.');
        }

        const payload = {
            ...data,
            user_id: clientId,
            seller_id: loggedUser.id,
        };
        delete payload.client_id;

        return axios.post(`${API_URL}/remissions`, payload, { headers: authHeader() });
    },
    updateData(id, data) {
        const loggedUser = JSON.parse(localStorage.getItem('user'));

        const payload = { ...data };
        const clientId = Number(
            payload.client_id !== undefined && payload.client_id !== null && payload.client_id !== ''
                ? payload.client_id
                : payload.user_id ?? 0
        );
        if (clientId) {
            payload.user_id = clientId;
        }
        delete payload.client_id;

        if (loggedUser?.id) {
            payload.seller_id = loggedUser.id;
        }

        return axios.put(`${API_URL}/remissions/${id}`, payload, { headers: authHeader() });
    },
    deleteData(id) {
        return axios.delete(`${API_URL}/remissions/${id}`, { headers: authHeader() });
    },
    getDoc(id) {
        return axios.get(`${API_URL}/remissions/export/${id}`, { headers: authHeader(), responseType: 'blob' });
    },
    getPdf(id) {
        return axios.get(`${API_URL}/remissions/export-pdf/${id}`, { headers: authHeader(), responseType: 'blob' });
    },
    getNote(id) {
        return axios.get(`${API_URL}/remissions/export-note/${id}`, { headers: authHeader(), responseType: 'blob' });
    },
    getNoStockNote(id) {
        return axios.get(`${API_URL}/remissions/export-no-stock-note/${id}`, { headers: authHeader(), responseType: 'blob' });
    },
    getPendingItems(ids = []) {
        const query = ids.length ? `?ids[]=${ids.join('&ids[]=')}` : '';
        return axios.get(`${API_URL}/remissions/export-pending-items${query}`, { headers: authHeader(), responseType: 'blob' });
    },
    getPendingOrders(ids = []) {
        const query = ids.length ? `?ids[]=${ids.join('&ids[]=')}` : '';
        return axios.get(`${API_URL}/remissions/export-pending-orders${query}`, { headers: authHeader(), responseType: 'blob' });
    },
    formalize(id) {
        return axios.post(`${API_URL}/remissions/${id}/formalize`, {}, { headers: authHeader() });
    },
    syncToShopify(id) {
        return axios.post(`${API_URL}/shopify/remissions/${id}/sync`, {}, { headers: authHeader() });
    },
    markPrepared(id, barcode) {
        return axios.post(`${API_URL}/remissions/${id}/mark-prepared`, { barcode }, { headers: authHeader() });
    },
    updatePreparado(id, preparado) {
        return axios.put(`${API_URL}/remissions/${id}/preparado`, { preparado }, { headers: authHeader() });
    },
};
